module.exports = __webpack_public_path__ + "static/media/business-lunch-hero.1339db27.jpg";